import Cookies from 'js-cookie';

export const CATALOG_SEARCH_SETTINGS_COOKIE_NAME = 'catalog-search-settings';

export function getCatalogSearchSettingsFromCookieClient() {
  const settingsFromCookie = Cookies.get(CATALOG_SEARCH_SETTINGS_COOKIE_NAME);
  return settingsFromCookie ? JSON.parse(settingsFromCookie) : {};
}

export function setCatalogSearchSettings(options: { [key: string]: string | number | boolean }) {
  const settingsFromCookie = getCatalogSearchSettingsFromCookieClient();
  const newValues = { ...settingsFromCookie, ...options };
  Cookies.set(CATALOG_SEARCH_SETTINGS_COOKIE_NAME, JSON.stringify(newValues));
}
